import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Divider from "components/common/Divider";

const FieldSection = ({ title, icon, description, fields, onSave }) => {
  // normalize fields, convert string to { value, type }
  const normalize = (fieldsObj) => {
    const result = {};
    for (const [key, val] of Object.entries(fieldsObj)) {
      if (typeof val === "string") {
        result[key] = { value: val, type: "text" }; // default type
      } else {
        result[key] = val; // already in {value, type} format
      }
    }
    return result;
  };
  const [editing, setEditing] = useState(false);
  const [formData, setFormData] = useState(normalize(fields));

  useEffect(() => {
    setFormData(normalize(fields));
  }, [fields]);

  const handleChange = (key, newValue) => {
    setFormData({
      ...formData,
      [key]: { ...formData[key], value: newValue },
    });
  };

  const handleSave = async () => {
    // extract plain values before save
    const cleaned = {};
    Object.entries(formData).forEach(([key, obj]) => {
      cleaned[key] = obj.value;
    });

    await onSave(cleaned);
    setEditing(false);
  };

  return (
    <>
      <h6 className="fw-bold text-sm">
        <FontAwesomeIcon icon={icon} className="me-2" />
        {title}
      </h6>

      <p className="mb-3 text-xxs">{description}</p>

      <div className="bg-lightdd p-3 rounded-3 px-4 relative edit-box">
        {!editing && (
          <div onClick={onSave ? () => setEditing(true) : undefined}>
            {Object.entries(formData).map(([key, obj], index, arr) => (
              <div
                key={key}
                className={`d-flex align-items-center gap-4 ${
                  index !== arr.length - 1 ? "mb-1" : ""
                }`}
              >
                <div style={{ flex: "0 0 25%" }}>
                  <label className="form-label text-xxs mb-0">{key}</label>
                </div>
                <div style={{ flex: 1 }}>
                  <h6 className="mb-0 fw-semibold text-xxs col-10">
                    {obj.value || "Not provided"}
                  </h6>
                </div>
              </div>
            ))}

            {onSave && (
              <FontAwesomeIcon
                icon="edit"
                className="edit-icon"
                onClick={() => setEditing(true)}
              />
            )}
          </div>
        )}

        {editing && (
          <div className="w-100">
            {Object.entries(formData).map(([key, obj]) => (
              <div key={key} className="mb-3 d-flex align-items-center gap-4">
                <div style={{ flex: 1 }}>
                  <label className="form-label text-xxs">{key}</label>
                </div>
                <div style={{ flex: 2 }}>
                  <input
                    type={obj.type || "text"}
                    className="form-control form-control-sm"
                    value={obj.value || ""}
                    onChange={(e) => handleChange(key, e.target.value)}
                    style={{ fontSize: 13 }}
                  />
                </div>
              </div>
            ))}

            <div className="d-flex gap-2">
              <button
                className="btn btn-sm btn-secondary text-xxs"
                onClick={() => setEditing(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-sm btn-success text-xxs"
                onClick={handleSave}
              >
                Save
              </button>
            </div>
          </div>
        )}
      </div>

      <Divider className="my-4" />
    </>
  );
};

export default FieldSection;
